module.exports = __webpack_public_path__ + "img/202506_07.6286d0a0.jpg";